import { render, staticRenderFns } from "./DockingDashboardFinish.vue?vue&type=template&id=8dd4c8f6&scoped=true"
import script from "./DockingDashboardFinish.vue?vue&type=script&lang=js"
export * from "./DockingDashboardFinish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd4c8f6",
  null
  
)

export default component.exports